export default "__VITE_ASSET__D8h$GB3b__"